import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";

export default function PoshPolicy(props) {
  const location = useLocation();
  const currentPath = location.pathname;

  const POSHpolicies = [
    { path: "/poshpolicy/", name: "Preliminary" },
    {
      path: "/poshpolicy/sexual-harassment",
      name: "What Constitutes Sexual Harassment?",
    },
    { path: "/poshpolicy/workplace", name: "What Constitutes Workplace?" },
    {
      path: "/poshpolicy/who-complain-sexual-harassment",
      name: "Who May Complain of Sexual Harassment?",
    },
    { path: "/poshpolicy/icc", name: "Internal Complaints Committee (ICC)" },
    {
      path: "/poshpolicy/complaint-of-sexual-harassment",
      name: "Complaint of Sexual Harassment",
    },
    {
      path: "/poshpolicy/punishment",
      name: "Punishment for false or malicious complaint and false evidence",
    },
    { path: "/poshpolicy/confidentiality", name: "Confidentiality & Appeal" },
    { path: "/poshpolicy/duties", name: "Duties of Slum Soccer Management" },
    {
      path: "/poshpolicy/review-and-approval",
      name: "Oversight, Amendments, Review & Approval",
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      <div className="bg-gradient-to-r from-[#efc94c] to-[#f0ce5d] py-16 pt-32">
        <div className="container mx-auto px-6">
          <h1 className="text-4xl font-bold text-white mb-4 text-center">
            Slum Soccer's Policy on Prevention of Sexual Harassment (POSH) of
            Women at Workplace (Version 2)
          </h1>
          <p className="text-sm text-white text-center italic">
            This Version 2 of the Policy has been approved by Dr.Abhijit Barse,
            CEO Slum Soccer and is effective from October 1, 2024.
          </p>
        </div>
      </div>

      {/* Main Content area */}
      <div className="container mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row gap-8">
          {/* Sidebar navigation */}
          <div className="md:w-1/4">
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">
                POSH Policy
              </h3>
              <ul className="space-y-2">
                {POSHpolicies.map((policy, index) => (
                  <li key={index}>
                    <Link
                      to={policy.path}
                      className={`block p-2 rounded-lg transition-colors ${
                        currentPath === policy.path
                          ? "bg-yellow-50 text-yellow-500 font-medium"
                          : "text-gray-600 hover:bg-gray-50"
                      }`}
                    >
                      {policy.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Main content area */}
          <div className="md:w-3/4">
            <div className="bg-white rounded-xl shadow-sm p-8">
              <Outlet />
            </div>
          </div>
        </div>

        {/* Added notification box at the bottom */}
        <div className="mt-8">
          <div className="rounded-xl p-6 bg-[#efc94c] text-white font-bold">
            <p>
              Please email or report any incident related to Sexual Harassment
              of Women at Slum Soccer's workplace to Ms.Shiba Marcus, Presiding
              Officer, ICC, SS at <a href="tel:+919637272665" className="hover:underline">+91 9637272665</a> Email ID:{" "}
              <a href="mailto:shiba.markas@slumsoccer.org" className="hover:underline">shiba.markas@slumsoccer.org</a> OR any other member of ICC OR to Dr.
              Abhijeet Barse, CEO, SS (<a href="mailto:abhijeet.barse@slumsoccer.org" className="hover:underline">abhijeet.barse@slumsoccer.org</a>)
            </p>
          </div>

          {/* Added disclaimer text */}
          <div className="mt-8 text-sm text-gray-500 text-justify">
            <p>
              Disclaimer: In case of any provision of this policy conveys a
              meaning or gets interpreted in a manner that is in conflict with
              the provisions of Sexual Harassment of Women at Workplace Act,
              2013 , the provisions of the Act will prevail.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
